// Vertical-slice spells and traps.

import type { RitualDef, SpellDef, TrapDef } from './types';

export const SPELLS: SpellDef[] = [
  {
    id: 'sp-ic-emergency-masonry',
    name: 'Emergency Masonry',
    faction: 'iron-covenant',
    targeting: { shape: 'entity', validTargets: 'friendly-building', range: 'global' },
    effects: [
      { fx: 'heal', amount: 450, overSeconds: 6 },
      { fx: 'tempHealth', amount: 300, duration: 15 },
    ],
  },
  {
    id: 'sp-ic-hold-the-line',
    name: 'Hold the Line',
    faction: 'iron-covenant',
    targeting: { shape: 'circle', radius: 9, range: 'global' },
    zoneDuration: 12,
    effects: [],
    // applied continuously to friendly non-giant squads inside the zone
    zoneBuffs: {
      appliesTo: 'friendly',
      excludeSizeTags: ['giant'],
      entries: [
        { filter: 'melee', stat: 'damageTaken', mult: 0.7 },
        { filter: 'ranged', stat: 'attackSpeed', mult: 1.15 },
      ],
    },
  },
  {
    // Bombardment zone: 4 s visible telegraph, then 6 impacts (bible IC-19's rectangular
    // lane simplified to a circle for the slice — documented deviation).
    id: 'sp-ic-judgment-barrage',
    name: 'Judgment Barrage',
    faction: 'iron-covenant',
    targeting: { shape: 'circle', radius: 9, range: 'global' },
    zoneDuration: 7.5, // 4 s telegraph + 6 impacts at 0.5 s cadence
    effects: [],
    bombardment: {
      telegraphSeconds: 4,
      impacts: 6,
      impactInterval: 0.5,
      impactRadius: 4.5,
      buildingDamage: 320,
      squadDamage: 150,
      workerDamage: 90,
      coreDamageMult: 0.4, // reduced direct Core damage (not a one-click finisher)
      largeMult: 1.6,
    },
  },
];

export const TRAPS: TrapDef[] = [
  {
    id: 'tr-ic-aegis-minefield',
    name: 'Aegis Minefield',
    faction: 'iron-covenant',
    pieceHealth: 180, // bible IC-20
    perDeploymentPieces: 3,
    buildTime: 10, // TEST — workers place three armored mines
    triggerRadius: 3,
    triggerSizeTags: ['medium', 'large', 'giant'],
    effects: [
      { fx: 'damage', amount: 150 }, // "moderate physical damage" — TEST
      { fx: 'slow', magnitude: 0.45, duration: 4 },
      { fx: 'mark', markId: 'giant-mark', duration: 8 },
    ],
    maxActiveFields: 2,
  },
];

export const RITUALS: RitualDef[] = [
  {
    // bible IC-22: 12 s channel at a controlled site or the Core
    id: 'rit-ic-march-of-the-last-wall',
    name: 'March of the Last Wall',
    faction: 'iron-covenant',
    channelSeconds: 12,
    channelAt: 'both',
    standardHealth: 600, // TEST
    refundFraction: 0.35,
  },
];
